import React from "react";
import { StyleSheet, View } from "react-native";

/**
 * Props for the GoogleMapsEmbed component.
 */
export interface IGoogleMapsEmbedProps {
  latitude: number;
  longitude: number;
  zoom?: number;
  style?: any;
}

/**
 * Web-specific Google Maps embed using an isolated iframe.
 * Renders a Google Maps pin at the specified latitude and longitude.
 *
 * @param {IGoogleMapsEmbedProps} props - The component props.
 * @returns {React.ReactElement} The rendered iframe element.
 */
export function GoogleMapsEmbed({ latitude, longitude, zoom = 15, style }: IGoogleMapsEmbedProps): React.ReactElement {
  const embedUrl = `https://maps.google.com/maps?q=${latitude},${longitude}&z=${zoom}&output=embed`;

  return (
    <View style={[styles.container, style]}>
      {React.createElement("iframe", {
        src: embedUrl,
        style: {
          width: "100%",
          height: "100%",
          border: 0,
          borderRadius: 8,
        },
        loading: "lazy",
        title: `Google Maps at ${latitude}, ${longitude}`,
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
    height: "100%",
    borderRadius: 8,
    overflow: "hidden",
  },
});
